import { useState, useCallback } from 'react';
import { useApp } from '../context/AppContext';
import { updateProfile as updateProfileService } from '../services/profile';

const MAX_AVATAR_SIZE = 5 * 1024 * 1024; // 5 MB

export default function useProfile() {
  const { userProfile: profile, setUserProfile, setProfileOpen } = useApp();
  const [loading, setLoading] = useState(false);

  const updateProfile = useCallback(async (fields) => {
    setLoading(true);
    try {
      const updated = await updateProfileService(fields);
      setUserProfile(updated);
    } finally {
      setLoading(false);
    }
  }, [setUserProfile]);

  const updateAvatar = useCallback(async (file) => {
    if (file.size > MAX_AVATAR_SIZE) {
      throw new Error('Image must be under 5MB');
    }

    // Revoke previous object URL if one exists
    if (profile.avatarUrl) {
      URL.revokeObjectURL(profile.avatarUrl);
    }

    const avatarUrl = URL.createObjectURL(file);
    setUserProfile({ avatarUrl });
  }, [profile.avatarUrl, setUserProfile]);

  return { profile, loading, updateProfile, updateAvatar, setProfileOpen };
}
